//  import AUTHS from

/**
 * Copied from ferp, should we add to GP lib? logging/auths/what else?
 * Exactly how this is implemented can be tweaked. The idea is to share the mechanism used
 * to evalaute the rules we contstruct between client and server
 */

export function evaluateAuthRequireAll(requiredAuthorizations = [], currentAuthorizations = []) {
    return requiredAuthorizations.every((auth) => currentAuthorizations.includes(auth));
}

export function evaluateAuthRequireAny(requiredAuthorizations = [], currentAuthorizations = []) {
    return requiredAuthorizations.some((auth) => currentAuthorizations.includes(auth));
}

export function evaluateAuthRequireNone(disallowedAuthorizations = [], currentAuthorizations = []) {
    return !disallowedAuthorizations.some((auth) => currentAuthorizations.includes(auth));
}

export function itemPassesAuthTest(item, currentAuthorizations) {
    // note defaulting this to false which is a change from the FERP code
    let passesAuthTest = false;
    if (item.authorizations) {
        const {
            authRequireAll = [],
            authRequireAny = [],
            authRequireNone = [],
        } = item.authorizations;
        if (authRequireAll.length) {
            // do 'all' check
            passesAuthTest =
                passesAuthTest && evaluateAuthRequireAll(authRequireAll, currentAuthorizations);
        }
        if (authRequireAny.length) {
            // do 'any' check
            passesAuthTest =
                passesAuthTest && evaluateAuthRequireAny(authRequireAny, currentAuthorizations);
        }
        if (authRequireNone.length) {
            passesAuthTest =
                passesAuthTest && evaluateAuthRequireNone(authRequireNone, currentAuthorizations);
        }
    }
    return passesAuthTest;
}

export function filterByAuthorizations(items, currentAuthorizations) {
    if (!items) return items;
    return items.filter((item) => {
        return itemPassesAuthTest(item, currentAuthorizations);
    });
}

export function filterByNOTAuthorizations(items, currentAuthorizations) {
    if (!items) return items;
    return items.filter((item) => {
        return !itemPassesAuthTest(item, currentAuthorizations);
    });
}
